export function copyCurrentURL() {
  navigator.clipboard.writeText(window.location.href);
}
